<template>
  <div class="center">
    <h1>{{ appName || "" }} Metrics - Política de Privacidad</h1>
    <img
      v-if="logo"
      :src="require(`../assets/images/${logo}`)"
      alt="Logo de Caribe Metrics"
      class="mb-5"
    />

    <policy-axesa
      v-if="appName.toLowerCase() == appNameConfig.AXESA"
    ></policy-axesa>

    <policy-caribe
      v-if="
        appName.toLowerCase() == appNameConfig.CARIBEMEDIA ||
          appName.toLowerCase() == appNameConfig.INFOPAGINAS
      "
    ></policy-caribe>

    <p class="text-justify">
      <a href="#"><router-link :to="`/`">Ir atrás</router-link></a>
    </p>

    <p v-if="googlePremierID">
      <a
        class="premier"
        target="_blank"
        :href="
          `https://www.google.com/partners/agency?id=${googlePremierID || null}`
        "
      >
        <img
          class="premier"
          src="https://www.gstatic.com/partners/badge/images/2025/PremierBadgeClickable.svg"
          alt="Badge de Google Partner"
        />
      </a>
    </p>
  </div>
</template>

<script>
import { BusinessUnitConfig } from "../config/businessUnitConfig";
import PolicyAxesa from "../components/PolicyAxesa.vue";
import PolicyCaribe from "../components/PolicyCaribe.vue";
import { APP_NAME_CONFIG } from "../constants";

export default {
  name: "privacy-policy",
  components: {
    PolicyAxesa,
    PolicyCaribe
  },
  async data() {
    return {
      appNameConfig: null,
      googlePremierID: null,
      appName: "",
      logo: ""
    };
  },
  created() {
    const {
      appName = "",
      googlePremierID = null,
      logoURL = ""
    } = BusinessUnitConfig[window.location.host];

    this.appName = appName;
    this.googlePremierID = googlePremierID;
    this.appNameConfig = APP_NAME_CONFIG;
    this.logo = logoURL;
  }
};
</script>

<style lang="scss" scoped>
.center {
  //position: fixed;
  margin-right: auto;
  margin-left: auto;
  //right: 0;
  //left: 0;
  width: 70%;

  padding: 20px;
  text-align: center;

  img {
    width: 250px;
  }

  img.premier {
    width: 150px !important;
  }

  .text-justify {
    text-align: justify;
    padding: 10px;
  }

  span.bold {
    font-weight: bold;
  }

  span.title {
    font-weight: bold;
    font-size: 15px;
    padding-bottom: 10px;
  }
}

.mb-5 {
  margin-bottom: 30px;
}
</style>
